module.exports = __webpack_public_path__ + "img/video-content/curveline--video-content.svg";